import { Link } from 'react-router-dom';
import { getLatestArticles } from '@/mocks/articles';

export default function FeaturedGrid() {
  const articles = getLatestArticles(6);

  return (
    <section className="w-full bg-background-100 py-12 md:py-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
              最新猛料
            </h2>
            <p className="text-sm text-foreground-500 mt-1">每日更新，深挖不为人知的内幕</p>
          </div>
          <Link
            to="/category/hot-events"
            className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {articles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all cursor-pointer"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                {article.isHot && (
                  <span className="absolute top-3 left-3 px-2 py-0.5 bg-primary-500 text-background-50 text-xs font-bold rounded-full whitespace-nowrap">
                    热门
                  </span>
                )}
                <span className="absolute top-3 right-3 px-2 py-0.5 bg-background-950/70 text-background-100 text-xs rounded-full whitespace-nowrap">
                  {article.category}
                </span>
              </div>
              <div className="p-5">
                <h3 className="font-bold text-foreground-900 group-hover:text-primary-500 transition-colors font-heading line-clamp-2 text-base">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 mt-2 line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between mt-4 pt-4 border-t border-background-200/70">
                  <div className="flex items-center gap-3 text-xs text-foreground-500">
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i> {article.views.toLocaleString()}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-message-2-line"></i> {article.comments.toLocaleString()}
                    </span>
                  </div>
                  <span className="text-xs text-foreground-400">{article.publishedAt}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}